export default __webpack_public_path__ + "static/media/instagram.0c16361e.svg";